import React from 'react';
import { View } from '@amzn/atoz-web/View';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { Text } from '@amzn/atoz-web/Text';
import { Col } from '@amzn/atoz-web/Col';
import { Row } from '@amzn/atoz-web/Row';
import { IconInformationFill } from '@amzn/atoz-web/Icons';
import { useTranslation } from 'react-i18next';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { useVTOAvailableCardData } from './utils';
export var VTOAvailableCard = function (_a) {
    var vtoOpportunity = _a.vtoOpportunity, setModalContent = _a.setModalContent, setModalError = _a.setModalError;
    var t = useTranslation().t;
    var _b = useVTOAvailableCardData({
        vtoOpportunity: vtoOpportunity,
        setModalContent: setModalContent,
        setModalError: setModalError
    }), openVtoConfirmation = _b.openVtoConfirmation, durationStr = _b.durationStr, intervalStr = _b.intervalStr;
    return (React.createElement(VTOAvailable, { dataTestId: "VTOAvailableCard", flexDirection: "row", padding: "16px", backgroundColor: "neutral0" },
        React.createElement(Row, { justifyContent: "space-between", width: "100%" },
            React.createElement(Col, { justifyContent: "center", gridGap: "S200" },
                React.createElement(Row, { gridGap: "S200", alignItems: "center" },
                    React.createElement(IconInformationFill, { color: "neutral60" }),
                    React.createElement(Text, { color: "neutral60", dataTestId: "VTOAvailableCardLegend" }, t('ess_shifts_vto_vtoCard_vtoAvailable'))),
                React.createElement(Text, { dataTestId: "VTOAvailableCardInterval" },
                    React.createElement("strong", null, intervalStr),
                    " (",
                    durationStr,
                    ")")),
            React.createElement(Button, { key: "ess_shifts_vto_vtoCard_accept", onClick: openVtoConfirmation, "aria-label": t('ess_shifts_vto_vtoCard_accept'), "alt-text": t('shift_management_common_button', {
                    label: t('ess_shifts_vto_vtoCard_accept')
                }), dataTestId: "VTOAvailableCardAcceptButton", variant: ButtonVariant.Tertiary, style: { height: 48 } }, t('ess_shifts_vto_vtoCard_accept')))));
};
var VTOAvailable = styledWithTheme(View)(function (_a) {
    var theme = _a.theme;
    return " \n    box-shadow: 0px 0px 5px 1px ".concat(theme.selectors.color('neutral20'), ";\n    ");
});
